import * as _ from 'lodash';
import {EntityType} from '@/shared/models/entityType';
import NodeBaseModel from "@/shared/models/abstract/nodeBaseModel";
import DataGenerator from "@/shared/DataGenerator";

export default class NoteModel extends NodeBaseModel {


    private _content: any;


    get content() {
        return this._content;
    }

    set content(value) {
        this._content = value;
        this.raisePropertyChanged('content');
    }


    constructor() {
        super(EntityType.Note, "NOTE");
        this._content = null;
    }


    static fromJson(json) {
        if (json.entityType !== EntityType.Note) {
            throw new Error('Wrong deserialization data.');
        }
        let m = new NoteModel();
        m = _.assign(m, json);
        return m;
    }

    toJson() {
        const m = super.toJson();

        m.content = this.content;
        return m;
    }
    clone() {
        const clone =  NoteModel.fromJson(this.toJson());
        clone.id = DataGenerator.id();
        return clone;
    }
};
